import { messageComparator as comparator } from './common';

export const MESSAGES_ARE_DELETABLE = false;

export const MESSAGES_TABLE_CONFIG = {
  columns: [{
    name: 'messages.table.header.content',
    dataField: 'title',
    expandable: true,
  }, {
    width: '23%',
    name: 'messages.table.header.status',
    dataField: 'statusCode',
    hideOnMobile: true,
  }, {
    width: '19%',
    name: 'messages.table.header.date',
    dataField: 'date',
  }],
  uniqueIdField: 'id',
  selectionField: 'selected',
  expandField: 'expanded',
  nameAsTranslationKey: true,
  useCheckboxSelection: MESSAGES_ARE_DELETABLE,
  sortable: true,
  comparator,
};
